import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import { CkeditorConstants } from "../../src/utils";

const { htmlElement: { PARAGRAPH, DIV }, helperAttributes: { RENUMBER_CITATIONS, DATA_CKE_TOOLTIP_TEXT, DATA_USERTOOLTIP, DATA_UNLOCK, CONTENTEDITABLE }, unLockValues: { no_one }, HEADINGS } = CkeditorConstants

export default class UpdatePlaceholderCommand extends Plugin {
    constructor(editor) {
        super(editor);
    }

    execute() {
        const placeholderNeededEle = [];
        const range = this.editor.model.createRangeIn(
            this.editor.model.document.getRoot()
        );
        for (const item of range.getItems({ ignoreElementEnd: true })) {
            if (
                item.hasAttribute(DATA_UNLOCK) &&
                item.getAttribute(DATA_UNLOCK) === no_one &&
                item.childCount === 1
            ) {
                placeholderNeededEle.push(item);
            }
        }

        placeholderNeededEle.forEach((parentEle) => {
            this.editor.model.enqueueChange({ isUndoable: false }, () => {
                this.editor.model.change(writer => {

                    if (parentEle.getChild(0).name === DIV) {
                        writer.remove(parentEle.getChild(0))
                    }

                    /**
                     * Adds paragraph back to NO-ONE elements when placeholder and subtemplate is removed
                     */
                    let placeholderAttrs = {
                        CONTENTEDITABLE: 'false'
                    };

                    /**
                     * Adds tooltip to new paragraph tag if available
                     */
                    if (parentEle.hasAttribute(DATA_USERTOOLTIP)) {
                        placeholderAttrs[DATA_CKE_TOOLTIP_TEXT] = parentEle.getAttribute(DATA_USERTOOLTIP);
                    }
                    if(!HEADINGS.includes(parentEle.name)) {
                        writer.insertElement(
                            PARAGRAPH,
                            { ...placeholderAttrs },
                            parentEle,
                            0
                        );
                    }

                    writer.setAttribute(CONTENTEDITABLE, 'true', parentEle)
                })
            });


        });
        this.editor.execute(RENUMBER_CITATIONS);
    }

    refresh() { }
}
